<template>
  <div class="mx-auto col-sm-8">
    <div class="row mb-2">
      <div class="form-group col-12">
        <label for="client">{{ $t("client") }}</label>

        <Combobox
          class="bg-white"
          name="client"
          :placeholder="$t('select_a_item')"
          :options="clients"
          :getOptionLabel="client => customOptionLabel(client)"
          v-model="clientSelected"
        />
      </div>
    </div>

    <div
      class="row mb-5"
      v-if="clientSelected"
    >
      <div class="col-12">
        <button
          :class="[checkHasSignature() ? 'btn-danger' : 'btn-primary']"
          class="btn"
          @click="setChecklist(checkHasSignature() ? false : true)"
        >
          {{ checkHasSignature() ? 'Desativar' : 'Ativar' }} Frotix Signature
        </button>
      </div>
    </div>

    <b-alert
      :show="alert.show"
      @dismissed='alert.show = false'
      dismissible
      fade
      :variant="alert.type || 'success'"
    >
      {{ alert.message }}
    </b-alert>
  </div>
</template>

<script>
import LoaderButton from "@/components/button/LoaderButton";
import Combobox from "@/components/shared/ComboBox";
import { request } from "@/lib/http";

const defaulAlert = {
  show: false,
  type: 'success',
}

export default {
  name: "Checklist",
  components: {
    LoaderButton,
    Combobox,
  },

  data() {
    return {
      clients: [],
      clientSelected: undefined,
      alert: defaulAlert,
      timeout: null
    };
  },

  methods: {
    async getClients() {
      const { dispatch } = this.$store;

      dispatch("overlay/show", true);

      try {
        this.clients = await request({
          url: "signature/clients",
          method: "get",
        })
      } catch (error) {
        console.log("[ERROR-GETTING-CLIENTS] => ", error);

        this.clients = [];
      } finally {
        dispatch("overlay/show", false);
      }
    },

    async setChecklist() {
      const { dispatch } = this.$store;

      dispatch("overlay/show", true);

      try {
        const { data } = await request({
          url: "set-status-signature",
          method: "post",
          data: {
            client: this.clientSelected
          },
        });

        await this.getClients()

        clearTimeout(this.timeout)
        this.alert.show = false

        this.alert = {
          show: true,
          message: `Frotix Signature ${this.clientSelected.maxfrota_signature ? 'Desativado' : 'Ativado'} com sucesso!`
        }

        this.timeout = setTimeout(() => this.alert = defaulAlert, 3000);

        this.clientSelected = undefined;
      } catch (error) {
        dispatch(
          "notify/error",
          {
            message: "Erro ao Ativar/Desativar Frotix Signature."
          }
        )
      } finally {
        dispatch("overlay/show", false);
      }
    },

    customOptionLabel(client) {
      const { CLI_DSC, maxfrota_signature, maxfrotaSignature } = client

      const hasSignature = maxfrota_signature || maxfrotaSignature

      return `${CLI_DSC} (${hasSignature ? 'SIM' : 'NÃO'})`
    },

    checkHasSignature() {
      const { maxfrota_signature, maxfrotaSignature } = this.clientSelected

      return Boolean(maxfrota_signature || maxfrotaSignature)
    }
  },

  async mounted() {
    await this.getClients()
  },
};
</script>
